// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2Zjlb","itemTitle":"ClientEmergencyInfo_itemTitle__1pbai","itemText":"ClientEmergencyInfo_itemText__2WPY8"};